/* eslint-disable global-require */

const messages = {
  ar: require('./ar.json'),
  cs: require('./cs.json'),
  de: require('./de.json'),
  en: require('./en.json'),
  es: require('./es.json'),
  eu: require('./eu.json'),
  fr: require('./fr.json'),
  it: require('./it.json'),
  pl: require('./pl.json'),
  ja: require('./ja.json'),
};

export default messages;



// WEBPACK FOOTER //
// ./src/i18n/index.js